import { __rest, __assign } from '../../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { VictoryChart, VictoryAxis, VictoryArea, VictoryLine } from 'victory';
import { ChartLayoutMini } from '../styles.js';
import { useChartData } from '../hooks.js';

var ZigChartMini = function (_a) {
    var data = _a.data, midLine = _a.midLine, height = _a.height, width = _a.width, _b = _a.gradientVariant, gradientVariant = _b === void 0 ? "mini" : _b, _c = _a.chartProps, chartProps = _c === void 0 ? {} : _c, precision = _a.precision, additionalProps = __rest(_a, ["data", "midLine", "height", "width", "gradientVariant", "chartProps", "precision"]);
    var _d = useChartData(data, gradientVariant, precision), processedData = _d.data, color = _d.color, gradient = _d.gradient;
    return (React__default.createElement(ChartLayoutMini, __assign({ height: height }, additionalProps),
        React__default.createElement(VictoryChart, __assign({ height: height, width: width, singleQuadrantDomainPadding: false, domainPadding: { x: 0, y: 1 }, padding: { top: 5, bottom: 10, left: 0, right: 0 } }, chartProps),
            React__default.createElement(VictoryAxis, { style: {
                    axis: { stroke: "transparent" },
                    ticks: { stroke: "transparent" },
                    tickLabels: { fill: "transparent" },
                } }),
            React__default.createElement(VictoryArea, { style: {
                    data: {
                        fill: "url(#".concat(gradient, ")"),
                        strokeWidth: 2,
                        stroke: color,
                    },
                }, data: processedData, interpolation: "monotoneX" }),
            midLine && (React__default.createElement(VictoryLine, { style: {
                    data: {
                        stroke: "grey",
                        strokeDasharray: 6,
                        strokeWidth: 2,
                        strokeOpacity: 0.7,
                    },
                }, data: [
                    { x: 0, y: 0 },
                    { x: processedData.length - 1, y: 0 },
                ] })))));
};

export { ZigChartMini as default };
